function EventMedia() {
  return <div>Event Media</div>;
}

export default EventMedia;
